import { useContext, useState } from "react"
import { AuthContext } from "../contexts/auth"
import getVideos from "../services/getVideos"
import deleteVideo from "../services/deleteVideo"
import toast from "react-hot-toast"

const useVideosState = () => {

    const { signOut } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [videoDeletar, setVideoDeletar] = useState(false)    
    const [pesquisa, setPesquisa] = useState('')
    const [videos, setVideos] = useState([])
    const [submit, setSubmit] = useState(false)
    

    const _getVideos = async (id) => {
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getVideos(`admin/listavideoscurso/${id}/`, pesquisa === '' ? null: pesquisa)
        if (result.type === 'success'){
            setVideos(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _deleteVideo = async () =>{
        if (submit){
            return;
        }
        setOpenDialog(false)
        setSubmit(true)
        let result = await deleteVideo(`admin/video/${videoDeletar.id}/`)
        if (result.type === 'success'){
            toast.success(result.data.detail)
            _getVideos(videoDeletar.cursos)
        }
        else if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }

        setSubmit(false)

    }

    return {
        videos: {value: videos, set:_getVideos},

        pesquisa: {value: pesquisa, set:setPesquisa},        
        openDialog: {value: openDialog, set:setOpenDialog},        
        deletar: {value: ()=>{console.log('não implementado')}, set: _deleteVideo},
        itemDelete:{value:videoDeletar, set:setVideoDeletar},  
        submit: {value: submit, set: _getVideos},
    }
}

export default useVideosState